import { ChecklistDocuments, GuaranteeType } from "@interfaces/catalogs";

export const filterChecklistByGuarantee = (
  documents: ChecklistDocuments,
  guarantee_type: GuaranteeType | undefined,
) => {
  const filtered_documents = documents.filter((item) => {
    if (item.guarantee_type_code) {
      if (item.guarantee_type_code === guarantee_type?.code) {
        return true;
      }
      return false;
    }
    return true;
  });
  return filtered_documents;
};
